module.exports = __webpack_public_path__ + "static/media/servicePhone.b8254cf4.png";